<template>
    <div>
        <v-btn
            @click="action == 'create' ? save() : edit()"
            data-cy="save"
            :disabled="disabled"
            class="buttons buttons--add"
        >
            {{ $t('global:save') }}
        </v-btn>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    i18nOptions: { namespaces: ['global'] },
    props: {
        action: {
            type: String,
        },
    },
    data() {
        return {
            disabled: false,
        }
    },

    methods: {
        ...mapActions(['createRole', 'updateRole']),
        async save() {
            this.disabled = true
            let success = await this.createRole()
            if (success) this.$emit('closeModal')
            this.disabled = false
        },
        async edit() {
            this.disabled = true
            let success = await this.updateRole()
            if (success) this.$emit('closeModal')
            this.disabled = false
        },
    },
}
</script>
